import { createFileRoute, redirect } from "@tanstack/react-router"

import {
  MEMBERSHIP_APPLICATION_BASE_PATH,
  membershipApplicationSteps,
} from "@/features/membership/application/constants"

export const Route = createFileRoute("/membership/apply/")({
  loader: () => {
    const firstStepPath =
      membershipApplicationSteps[0]?.path ||
      `${MEMBERSHIP_APPLICATION_BASE_PATH}/category`

    throw redirect({ to: firstStepPath })
  },
})
